import React, { useEffect, useState } from 'react'
import { Editor } from '@tinymce/tinymce-react';
import './style.scss'
import { KEY_TINY } from 'env';

const insertItems = [
  { text: 'name', value: 'name' },
  { text: 'email', value: 'email' },
  { text: 'birtday', value: 'birtday' },
  { text: 'phone', value: 'phone' },
];

interface TinyMceProps {
  option?: Record<string, any>;
  onChange?: (content: string) => void;
  defaultValue?: string;
}

const TinyMce: React.FC<TinyMceProps> = ({ option = {}, onChange, defaultValue = '' }) => {
  const [str, setStr] = useState(defaultValue);

  useEffect(() => {
    if (defaultValue === 'reset') {
      setStr('');
    } else {
      setStr(defaultValue || '');
    }
  }, [defaultValue]);

  // Custom plugin registration
  const handleEditorInit = (evt: any, editor: any) => {
    // Prevent registering multiple times
    if (editor.plugins.myInsertPlugin) return;

    editor.ui.registry.addMenuButton('insertvar', {
      text: 'Markup',
      fetch: (callback: any) => {
        const items = insertItems.map(item => ({
          type: 'menuitem',
          text: item.text,
          onAction: () => {
            editor.insertContent(`{{${item.value}}}`);
          }
        }));
        callback(items);
      }
    });

    // Mark as registered to avoid re-adding
    editor.plugins.myInsertPlugin = true;
  };

  return (
    <div className='gb-tinymce'>
      <Editor
        apiKey={KEY_TINY}
        value={str}
        onInit={handleEditorInit}
        init={{
          plugins: 'preview importcss searchreplace autolink directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion',
          toolbar: "insertvar | undo redo | accordion accordionremove | blocks fontfamily fontsize | bold italic underline strikethrough | align numlist bullist | link image | table media | lineheight outdent indent| forecolor backcolor removeformat | charmap emoticons | code fullscreen preview | save print | pagebreak anchor codesample | ltr rtl",
          ...option
        }}
        onEditorChange={(content: any) => {
          onChange && onChange(content)
          setStr(content)
        }}
      />
    </div>
  );
};

export default TinyMce;